import { useState } from 'react';
import { HoursData } from '../../../../datastore/hours.json';
import { MinutesData } from '../../../../datastore/minutes.json';
import { CARD_PLACEHOLDER_IMAGE, existingCreditCardData } from '../constants';

let _currentTime = sessionStorage.getItem('session_locationTime') === ''
  ? new Date()
  : new Date(sessionStorage.getItem('session_locationTime'));
let _currentHour = new Date(_currentTime).getHours();
let _currentMinute = new Date(_currentTime).getMinutes();

function buildInitialState(customer, tripDetails, rateLookup) {
  _currentTime = sessionStorage.getItem('session_locationTime') === ''
    ? new Date()
    : new Date(sessionStorage.getItem('session_locationTime'));
  _currentHour = new Date(_currentTime).getHours();
  _currentMinute = new Date(_currentTime).getMinutes();

  return {
    rideId: tripDetails == null ? 0 : tripDetails.rideId,
    rateLookup: rateLookup == null ? null : rateLookup,
    customer,
    paxFirstName: '',
    paxLastName: '',
    countryCodePhone: '1',
    phoneNumber: '',
    countryCode: '1',
    mobileNumber: '',
    email: '',
    isSendEmail: false,
    poNumber: '',

    bookingAddress: [],
    dropdownZone: [],
    isPickupGoogleBooking: false,
    pickupSuggestions: [],
    pickupLocation: '',
    pickupZoneId: 0,
    pickupAddress: '',
    pickupAddressType: '',
    pickupCity: '',
    pickupState: '',
    pickupZipCode: '',
    pickupLatitude: 0,
    pickupLongitude: 0,
    isDropoffGoogleBooking: false,
    dropoffSuggestions: [],
    dropoffLocation: '',
    dropoffZoneId: 0,
    dropoffAddress: '',
    dropoffAddressType: '',
    dropoffCity: '',
    dropoffState: '',
    dropoffZipCode: '',
    dropoffLatitude: 0,
    dropoffLongitude: 0,
    serviceSourceId: 1,
    dropdownAffiliates: [],
    otherAffiliateId: 0,
    dropdownHours: HoursData,
    dropdownMinutes: MinutesData,

    dropdownAirline: [],
    airlineId: customer ? customer.airlineId : 0,
    flightNumber: '',
    terminalType: 0,
    terminal: '',
    flightHour: _currentHour,
    flightMinute: _currentMinute,
    flightTime: new Date(_currentTime.getFullYear(), _currentTime.getMonth(), _currentTime.getDate(), _currentHour, _currentMinute),

    airlineIdReturn: customer ? customer.airlineId : 0,
    flightNumberReturn: '',
    terminalTypeReturn: 0,
    terminalReturn: '',
    flightHourReturn: _currentHour,
    flightMinuteReturn: _currentMinute,
    flightTimeReturn: new Date(_currentTime.getFullYear(), _currentTime.getMonth(), _currentTime.getDate(), _currentHour, _currentMinute),

    orderByName: '',
    countryCodeOrderPhone: '',
    phoneNumberOrder: '',
    emailOrder: '',
    dropdownReservationMode: [],
    reservationModeId: 0,
    puDateTime: _currentTime,
    puDateTimeReturn: _currentTime,

    doDateTime: _currentTime,
    tripDuration: 0,
    dropdownVehicleType: [],
    vehicleTypeId: 0,
    noOfPax: 1,
    noOfPaxReturn: 1,
    luggage: 0,
    noOfTrip: 1,
    isAccessible: false,
    isVipTrip: false,
    isPriorityTrip: false,
    isMeetGreet: false,
    tripTypeId: '1',
    isLockRates: false,
    recurringTypeId: 2,
    recurringEndDate: '',
    selectedDays: [],
    isWeekSun: false,
    isWeekMon: false,
    isWeekTue: false,
    isWeekWed: false,
    isWeekThu: false,
    isWeekFri: false,
    isWeekSat: false,
    isMonthSun: false,
    isMonthMon: false,
    isMonthTue: false,
    isMonthWed: false,
    isMonthThu: false,
    isMonthFri: false,
    isMonthSat: false,
    specialInstruction: '',
    permanentRemark: '',
    pickupNotes: '',
    billToNotes: '',
    customerRateTax: null,

    dropdownPaymentType: [],
    paymentTypeId: 1,
    dropdownVoucherCompany: [],
    voucherCompanyId: 0,
    paymentTermId: 1,
    dropdownExistingCards: [],
    existingCardId: 0,
    cardExpiry: '',
    cardType: '',
    cardImage: CARD_PLACEHOLDER_IMAGE,
    creditCard: '',
    checkNumber: '',
    checkDate: '',
    checkBank: '',
    chargeTo: '',
    voucherCode: '',

    rideAmount: 0.0,
    tollAmount: 0.0,
    tipAmount: 0.0,
    otAmount: 0.0,
    serviceFeeAmount: 0.0,
    fuelSurcharge: 0.0,
    parkingFee: 0.0,
    tourGuideCharge: 0.0,
    payToTourGuide: 0.0,
    extraAmount: 0.0,
    extraAmountFor: '',
    waitingCharge: 0.0,
    waitingTime: 0,
    waitingChargeTotal: 0.0,
    extraStopCharge: 0.0,
    noOfStops: 0,
    stopTotal: 0.0,
    meetGreet: 0.0,
    mgToPay: '2',
    dropdownGreeter: [],
    payMeetGreetId: 0,
    payMeetGreetAmount: 0.0,
    mgDriverComms: '1',
    dropdownAgentCommission: [],
    agentCommissionId: 0,
    agentCommissionName: '',
    agentCommissionAmount: 0.0,
    discount: 0.0,

    portAuthority: 0.0,
    utitity: 0.0,
    countyTax: 0.0,
    congestionTax: 0.0,
    workCompantation: 0.0,
    salesTax: 0.0,
    grossAmount: 0.0,
    totalFare: 0.0,
    paidAmount: 0.0,

    loadPanelVisible: false,
    isCopy: false,
    isAttachment: false,
    notesTab: 'trip',
    fareView: 'customer',

    chkPaymentGatewaySelection: '1',

    errors: {
      paxFirstName: '',
      paxLastName: '',
      countryCode: '',
      mobileNumber: '',
      email: '',
      pickupLocation: '',
      pickupZoneId: '',
      dropoffLocation: '',
      dropoffZoneId: '',
      otherAffiliateId: '',
      puDateTime: '',
      doDateTime: '',
      flightTime: '',
      flightNumber: '',
      terminalType: '',
      flightNumberReturn: '',
      terminalTypeReturn: '',
      flightTimeReturn: '',
      orderByName: '',
      reservationModeId: '',
      vehicleTypeId: '',
      noOfTrip: '',
      noOfPax: '',
      noOfPaxReturn: '',
      recurringEndDate: '',
      recurring: '',
      rideAmount: '',
      payMeetGreetId: '',
      payMeetGreetAmount: '',
      paymentTypeId: '',
      paidAmount: '',
      checkNumber: '',
      checkDate: '',
      checkBank: '',
      existingCardId: '',
      creditCard: '',
      cardType: '',
      cardExpiry: '',
      voucherCompanyId: '',
      voucherCode: '',
    },
  };
}

export function useCharterState(customer, tripDetails, rateLookup) {
  const [state, setStateRaw] = useState(() => buildInitialState(customer, tripDetails, rateLookup));

  const setState = (partial) =>
    setStateRaw((prev) => ({
      ...prev,
      ...(typeof partial === 'function' ? partial(prev) : partial),
    }));

  return { state, setState };
}
